import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Credly|Management|Credly Data|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal' | 'htmlAllowed'> = {
	shared: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
	htmlAllowed: false,
};

type LocNameStart = 'SPCredlyManagementCredlyData';
export type SPCredlyManagementCredlyDataLocNames =
	| `${LocNameStart}TitleCredlyData`
	| `${LocNameStart}LabelEmail`
	| `${LocNameStart}LabelIssuedTo`
	| `${LocNameStart}LabelBadgeName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpiryDate`
	| `${LocNameStart}LabelCredlyId`
	| `${LocNameStart}LabelCreatedDate`;

export const spCredlyManagementCredlyDataLocs: LocDefs<SPCredlyManagementCredlyDataLocNames> = {
	SPCredlyManagementCredlyDataTitleCredlyData: {
		defaultValue: 'Credly Data',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.PageSectionTitle.CredlyData',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelEmail: {
		defaultValue: 'Email',
		description: 'Column heading for: Email.',
		displayPath: `${pathStart}Email`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.Email',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelIssuedTo: {
		defaultValue: 'Issued To',
		description: 'Column heading for: Issued To.',
		displayPath: `${pathStart}Issued To`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.IssuedTo',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelBadgeName: {
		defaultValue: 'Badge Name',
		description: 'Column heading for: Badge Name.',
		displayPath: `${pathStart}Badge Name`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.BadgeName',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelExpiryDate: {
		defaultValue: 'Expiry Date',
		description: 'Column heading for: Expiry Date.',
		displayPath: `${pathStart}Expiry Date`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.ExpiryDate',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelCredlyId: {
		defaultValue: 'Credly ID',
		description: 'Column heading for: Credly ID.',
		displayPath: `${pathStart}Credly ID`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.CredlyID',
		...sharedProperties,
	},
	SPCredlyManagementCredlyDataLabelCreatedDate: {
		defaultValue: 'Date Created',
		description: 'Column heading for: Date Created.',
		displayPath: `${pathStart}Date Created`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.ColumnHeading.CreatedDate',
		...sharedProperties,
	},
};

export type SPCredlyManagementCredlyDataLocType = LocMap<SPCredlyManagementCredlyDataLocNames>;
